import { loadVideoPlayer } from "./video-player.js";
import { app, loggedIn } from "./app.js";
import { get } from "./state.js";

export function home() {
  console.log("Loading home route");
  console.log(get("county"), get("school"));

  for (let video of document.querySelectorAll(
    ".elementor-custom-embed-image-overlay"
  )) {
    video.onclick = loadVideoPlayer(0, (evt) => {
      let iframe = document.querySelector(".elementor-video-iframe");
      let iframeSrc = iframe.src;
      iframe.remove();
      return iframeSrc;
    });
  }

  for (let video of document.querySelectorAll(".itp-home-video a")) {
    video.onclick = loadVideoPlayer(0, (evt) => evt.target.parentElement.href);
  }

  const loginBtn = document.querySelector("#itp-home-login-button a");
  const footerLoginBtn = document.querySelector("#itp-footer-login-button a");
  const loginBtnImg = document.querySelector("#itp-home-login-button a > img");
  const footerLoginBtnImg = document.querySelector(
    "#itp-footer-login-button a > img"
  );
  const getStartedSection = document.querySelector("#get-started-section");

  if (loginBtn != null && loginBtnImg != null) {
    if (loggedIn()) {
      loginBtn.href = "/logout/";
      loginBtnImg.src =
        "https://itpcareerexpo.com/wp-content/uploads/2020/10/logout-button.gif";
    }
  }

  if (footerLoginBtn != null && footerLoginBtnImg != null) {
    if (loggedIn()) {
      footerLoginBtn.href = "/logout/";
      footerLoginBtnImg.src =
        "https://itpcareerexpo.com/wp-content/uploads/2020/10/logout-button.gif";
    }
  }

  if (loggedIn()) {
    getStartedSection.style.display = "none";
  }
}

export default {};
